import {categoriesUsageSetting} from '@/library/task/task';
import {type Module} from 'vuex';
import actions from './actions';
import mutations from './mutations';

// state
const state: ModuleTaskState = {
    error: null,
    fetch: null,
    isFetched: false,
    categories: {},
    admin: false,
    employees: {},
    employeeFilter: [],
    entities: {},
    categoriesUsage: categoriesUsageSetting.personal,
};

// module
const task: Module<ModuleTaskState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
};

export default task;